import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { setUserSession, getToken } from "../Utils/Common";
import { getFirstPagePath, validateRoutesByRole } from "../Utils/Authorization";
import { useDispatch, useSelector } from "react-redux";
import { getCompany } from "../api/AccountsApi";
import {
  setUserRole,
  setUserEmail,
  setUserId,
  setCompanyLevelComplaiceFlag,
  setCompanyType,
} from "ReduxStore/Slices/userSlice";
import "bootstrap";
import { toast } from "react-toastify";

const Login = (props) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showPassword, seShowPassword] = useState(false);
  const [typeChange, setTypeChange] = useState("password");
  const [resetP, setResetP] = useState(false);
  const emailField = useRef("");
  const passwordField = useRef("");
  const dispatch = useDispatch();
  const { role } = useSelector((state) => state.userSetter);
  var x = localStorage.getItem("resetPass");
  if (x != null || x != undefined) {
    if (x == "true" || x == true) {
      setResetP(true);
      localStorage.setItem("resetPass", "false");
    }
  }

  // handle button click of login form
  const handleLogin = (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    dispatch(setUserEmail(emailField.current.value));
    localStorage.setItem(
      "KW-userEmail",
      JSON.stringify(emailField.current.value)
    );
    axios
      .post(process.env.REACT_APP_API_BASE_URL + "login", {
        email: emailField.current.value,
        password: passwordField.current.value,
      })
      .then(async (response) => {
        localStorage.setItem("keptLogged", "true");
        setLoading(false);
        dispatch(setUserRole(response.data.role));
        dispatch(setUserId(response.data.userId));
        setUserSession(
          response.data.token,
          response.data.user,
          response.data.role
        );
        await getCompany()
          .then((data) => {

            dispatch(setCompanyLevelComplaiceFlag(data.isComplianceActive));
            dispatch(setCompanyType( data.isKwLeadCompany?'lead' :''));

          })
          .catch((e) => {
            toast.error(e.message);
          });
        localStorage.setItem('SkipGuide', response.data.guideSkipped)
        localStorage.setItem('userGuideStep', response.data.guideStep)
        props.history.push(getFirstPagePath(response.data.role));
        validateRoutesByRole();

      })
      .catch((error) => {

        setLoading(false);
        if (error.status === 401) setError(error.data.message);
        else setError("Username or Password is in-correct. Please try again.");
      });
  };

  const showPasswordHander = (e) => {
    // 
    e.preventDefault();
    if (showPassword) {
      seShowPassword(false);
      setTypeChange("password");
    } else {
      seShowPassword(true);
      setTypeChange("text");
    }
    // seShowPassword
  };

  useEffect(() => {

    if (
      getToken() != null &&
      getToken() != "" &&
      localStorage.getItem("KW-userEmail") != null &&
      localStorage.getItem("KW-userEmail") != undefined &&
      localStorage.getItem("KW-userEmail") != ""
    ) {
      props.history.push(getFirstPagePath(role));
      validateRoutesByRole();
    }
  }, [role]);

  return (
    <body>
      <div class="container">
        <div class="row">
          <div class="col-sm-9 col-md-7 col-lg-6 mx-auto mt-4">
            <div style={{ position: "absolute", top: "-10px", right: "-80px" }}>
              <img
                alt="Kapitalwise"
                src={require("assets/img/login_top_back.svg")}
              />
            </div>
            <div
              class="card my-5 border border-1"
              style={{
                borderColor: "#A6ABC9",
                borderRadius: "20px",
                zIndex: "1",
              }}
            >
              <div class="card-body p-5">
                <div className="d-flex justify-content-center align-items-center p-2">
                  <img
                    alt="Kapitalwise"
                    src={require("assets/img/logo.svg")}
                    style={{ width: "3em", height: "3em" }}
                  />{" "}
                  <span className="nav_brand_text">Kapitalwise</span>
                </div>
                <div className="login_title d-flex justify-content-center align-items-center p-2">
                  <text>Login to your Kapitalwise account</text>
                </div>
                <div className="login_create_new d-flex justify-content-center align-items-center p-2">
                  <text>
                    Are you new here?{" "}
                    <a
                      style={{ color: "#2C40CE", fontWeight: 500 }}
                      to=""
                      href="/signup?plan=free"
                      target="_blank"
                    >
                      Request a free account
                    </a>
                  </text>
                </div>

                <form onSubmit={handleLogin}>
                  <div
                    class="form-floating mb-3"
                    style={{ lineHeight: "35px" }}
                  >
                    <text className="text-label-1">Username</text>
                    <input
                      type="email"
                      class="form-control m-0"
                      id="floatingInput"
                      ref={emailField}
                    />
                  </div>
                  <div
                    class="form-floating mb-3"
                    style={{ lineHeight: "35px" }}
                  >
                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                      <text className="text-label-1">Password</text>
                      <a
                        to=""
                        href="/forgotPassword"
                        target="_blank"
                        className="forgertPassword"
                        style={{ color: "#2C40CE" }}
                      >
                        Forgot Password ?
                      </a>
                    </div>

                    <div style={{ position: "relative" }}>
                      <input
                        type={typeChange}
                        class="form-control m-0"
                        id="floatingPassword"
                        ref={passwordField}
                      />
                      <span
                        className="input_icon"
                        style={{
                          position: "absolute",
                          top: "0px",
                          right: "10px",
                        }}
                      >
                        {!showPassword ? (
                          // "show"
                          <i onClick={showPasswordHander} class="fas fa-eye">
                            {" "}
                          </i>
                        ) : (
                          <i
                            onClick={showPasswordHander}
                            class="fas fa-eye-slash"
                          ></i>
                        )}{" "}
                      </span>{" "}
                    </div>
                  </div>
                  {error && (
                    <>
                      <small id="er" style={{ color: "red" }}>
                        {error}
                      </small>
                      <br />
                    </>
                  )}
                  <div class="login_btn">
                    <button class="xl_btn primary w_100 mt-2" type="submit">
                      {loading ? "Loading..." : "Login"}
                    </button>
                  </div>
                  {/* <div class="form-check d-flex justify-content-center align-items-center mt-3">
                    <div>
                      <input type="checkbox" value="" />
                      <text
                        class="login_create_new "
                        for="rememberPasswordCheck"
                      >
                        keep me logged in
                      </text>
                    </div>
                  </div> */}
                </form>
              </div>
            </div>
            <div style={{ position: "absolute", bottom: "0px", left: "-40px" }}>
              <img
                alt="Kapitalwise"
                src={require("assets/img/login_bottom_back.svg")}
              />
            </div>
          </div>
        </div>
      </div>
    </body>
  );
}

export default Login;
